import { forwardRef } from 'react';

import { IconProps } from '../';

export const TimelineStarIcon = forwardRef<SVGSVGElement, IconProps>(({ className, size = 20, ...props }, ref) => {
  return (
    <svg width={size} height={size} viewBox="0 0 20 20" ref={ref} {...props} {...{ className }}>
      <g clipPath="url(#clip0_4003_40713)">
        <g filter="url(#filter0_d_4003_40713)">
          <path
            d="M9.09194 3.96866C9.44936 3.19379 10.5506 3.19379 10.9081 3.96866L12.0226 6.38508C12.1683 6.70089 12.4676 6.91833 12.813 6.95928L15.4555 7.2726C16.3029 7.37307 16.6432 8.42046 16.0167 8.99983L14.063 10.8066C13.8077 11.0427 13.6934 11.3945 13.7611 11.7356L14.2798 14.3457C14.4461 15.1827 13.5551 15.83 12.8105 15.4132L10.4884 14.1134C10.185 13.9435 9.81503 13.9435 9.51156 14.1134L7.1895 15.4132C6.44489 15.83 5.55393 15.1827 5.72024 14.3457L6.23885 11.7356C6.30663 11.3945 6.19232 11.0427 5.93698 10.8066L3.98325 8.99983C3.35675 8.42046 3.69707 7.37307 4.54446 7.2726L7.18704 6.95928C7.5324 6.91833 7.83169 6.70089 7.97736 6.38508L9.09194 3.96866Z"
            fill="#CD650F"
          />
          <path
            d="M8.18359 3.5498C8.89842 2.00006 11.1016 2.00006 11.8164 3.5498L12.9307 5.96582L15.5732 6.2793C17.268 6.48024 17.9483 8.57564 16.6953 9.73438L14.7422 11.541L15.2607 14.1504C15.5933 15.8242 13.8114 17.1194 12.3223 16.2861L10 14.9863L7.67773 16.2861C6.18857 17.1194 4.40667 15.8242 4.73926 14.1504L5.25781 11.541L3.30469 9.73438C2.05169 8.57564 2.73197 6.48024 4.42676 6.2793L7.06934 5.96582L8.18359 3.5498Z"
            fill="none"
            stroke="white"
            strokeWidth="2"
          />
        </g>
      </g>
      <defs>
        <filter
          id="filter0_d_4003_40713"
          x="-0.341446"
          y="0.387695"
          width="20.6829"
          height="20.1606"
          filterUnits="userSpaceOnUse"
          colorInterpolationFilters="sRGB">
          <feFlood floodOpacity="0" result="BackgroundImageFix" />
          <feColorMatrix in="SourceAlpha" type="matrix" values="0 0 0 0 0 0 0 0 0 0 0 0 0 0 0 0 0 0 127 0" result="hardAlpha" />
          <feOffset dy="1" />
          <feGaussianBlur stdDeviation="1" />
          <feComposite in2="hardAlpha" operator="out" />
          <feColorMatrix type="matrix" values="0 0 0 0 0 0 0 0 0 0 0 0 0 0 0 0 0 0 0.2 0" />
          <feBlend mode="normal" in2="BackgroundImageFix" result="effect1_dropShadow_4003_40713" />
          <feBlend mode="normal" in="SourceGraphic" in2="effect1_dropShadow_4003_40713" result="shape" />
        </filter>
        <clipPath id="clip0_4003_40713">
          <rect width="20" height="20" fill="white" />
        </clipPath>
      </defs>
    </svg>
  );
});

export default TimelineStarIcon;
